import "./styles/global.scss";
import { PrimeReactProvider,  } from 'primereact/api';
import "primereact/resources/themes/lara-light-cyan/theme.css";
import { createTheme, CssBaseline, ThemeProvider } from '@mui/material';

import AppRoutes from './routes';
import { createContext, useState } from "react";
import UserContext, { UserProvider } from "./context";
import { IProfile } from "./interfaces/usuarios";
import WhatsAppChat from "./components/whatsapp";

const App = () => {

  const Context = createContext({});

  const [user, setUser] = useState<IProfile | null | undefined>();

  const theme = createTheme({
    palette: {
      primary: {
        main: '#61b4c0', // Cor primária personalizada
      },
      secondary: {
        main: '#0786d0', // Cor secundária personalizada
      },
      warning: {
        main: '#004387'
      }
      
    },
  });
  
  return (
    <UserProvider>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <PrimeReactProvider>
          <div className="App">
            <AppRoutes/>
            <WhatsAppChat/>
          </div>
        </PrimeReactProvider>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;
